var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vca-input"},[_c('vca-dropdown',{ref:"reference",attrs:{"label":_vm.label,"errorMsg":_vm.errorMsg,"placeholder":_vm.placeholder,"rules":_vm.rules,"options":_vm.options},on:{"input":_vm.change},model:{value:(_vm.current),callback:function ($$v) {_vm.current=$$v},expression:"current"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }